import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import Swal from "sweetalert2";

import { CCol, CRow } from "@coreui/react";

import { phieuChamDiemNCCApi } from "src/1/apis/phieu_cham_diem_nha_cung_cap.api";
import { useTabs } from "src/1/hooks/tab";
import { history } from "src/App";
import { CDate, CInput, CSelect } from "src/common/components/controls";
import { CActionGroup } from "src/common/components/others";

import { KY_DANH_GIA_OPTIONS, YEAR_OPTIONS } from "../../constants";
import { defaultValues, resolver } from "../../form";

export const FormToolbar = ({ editData, mode, setMode, setId }) => {
  //#region Data
  const params = useParams();

  const { offCurrentTab } = useTabs(
    params?.id ? "/supplier-suggest/form/:id" : "/supplier-suggest/form"
  );

  const {
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm({
    mode: "all",
    defaultValues,
    resolver,
  });
  //#endregion

  useEffect(() => {
    if (editData) {
      reset({
        code: editData?.code ?? defaultValues.code,
        cycle: editData?.cycle ?? defaultValues.cycle,
        year: editData?.year ?? defaultValues.year,
        evaluation_date: editData?.evaluation_date
          ? dayjs(defaultValues.evaluation_date).format("YYYY-MM-DD")
          : defaultValues.evaluation_date,
        note: editData?.note ?? defaultValues.note,
      });
    }
  }, [editData]);

  //#region Event
  const onSubmit = handleSubmit(async (values) => {
    try {
      let res = "";
      if (editData) {
        const { id } = editData;
        await phieuChamDiemNCCApi.update(id, values);
      } else {
        res = await phieuChamDiemNCCApi.create(values);
      }

      const result = await Swal.fire({
        title: "Lưu thông tin phiếu đề xuất thành công!",
        html: "Bạn có muốn cập nhật nhà cung cấp<br/>cho phiếu đề xuất này?",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "Có",
        cancelButtonText: "Không",
      });

      if (result.isConfirmed) {
        setMode("supplier");
        if (res?.data?.data) setId(res?.data?.data?.id);
      } else {
        reset(defaultValues);
        offCurrentTab();
        history.push("/supplier-rating/list");
      }
    } catch (error) {
      noti(
        "error",
        error?.message ?? "Lưu đề xuất nhà cung cấp không thành công!"
      );
    }
  });

  const onSelectChange = (changeCb) => (selectedOption) => {
    changeCb(selectedOption?.value);
  };
  //#endregion

  //#region Render
  return (
    <>
      <CRow>
        <CCol xs="12" className="action">
          <div>
            <CActionGroup
              onClick={onSubmit}
              canAdd={false}
              canSave={mode === "form" && !isSubmitting}
            />
          </div>
        </CCol>
      </CRow>

      <div className="flex items-center gap-4 mt-4">
        <Controller
          control={control}
          name="code"
          render={({ field }) => (
            <CInput
              {...field}
              className="flex-1 max-w-[250px]"
              label="Số phiếu"
              readOnly
            />
          )}
        />
        <Controller
          control={control}
          name="cycle"
          render={({ field: { onChange, ..._field } }) => (
            <CSelect
              {..._field}
              onChange={onSelectChange(onChange)}
              className="flex-1 max-w-[150px]"
              label="Kỳ đánh giá"
              options={KY_DANH_GIA_OPTIONS ?? []}
              disabled={mode !== "form"}
            />
          )}
        />
        <Controller
          control={control}
          name="year"
          render={({ field: { onChange, ..._field } }) => (
            <CSelect
              {..._field}
              onChange={onSelectChange(onChange)}
              className="flex-1 max-w-[150px]"
              label="Năm"
              options={YEAR_OPTIONS ?? []}
              disabled={mode !== "form"}
            />
          )}
        />
        <Controller
          control={control}
          name="evaluation_date"
          render={({ field }) => (
            <CDate
              {...field}
              className="flex-1 max-w-[200px]"
              label="Ngày đánh giá"
              disabled={mode !== "form"}
            />
          )}
        />
        <Controller
          control={control}
          name="note"
          render={({ field }) => (
            <CInput
              {...field}
              className="flex-1"
              label="Ghi chú"
              disabled={mode !== "form"}
            />
          )}
        />
      </div>
    </>
  );
  //#endregion
};
